import { render, staticRenderFns } from "./manage-social.vue?vue&type=template&id=2b5efea1&"
import script from "./manage-social.vue?vue&type=script&lang=js&"
export * from "./manage-social.vue?vue&type=script&lang=js&"
import style0 from "./manage-social.vue?vue&type=style&index=0&id=2b5efea1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports